/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ModerationDefs from './defs.defs.js'

const $nsid = 'tools.ozone.moderation.scheduleAction'

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  action: /*#__PURE__*/ l.typedUnion(
    [/*#__PURE__*/ l.typedRef<Takedown>((() => takedown) as any)],
    false,
  ),
  subjects: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'did' }), {
    maxLength: 100,
  }),
  createdBy: /*#__PURE__*/ l.string({ format: 'did' }),
  scheduling: /*#__PURE__*/ l.ref<SchedulingConfig>(
    (() => schedulingConfig) as any,
  ),
  modTool: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<ModerationDefs.ModTool>(
      (() => ModerationDefs.modTool) as any,
    ),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.payload(
  'application/json',
  /*#__PURE__*/ l.ref<ScheduledActionResults>(
    (() => scheduledActionResults) as any,
  ),
)

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Schedule a moderation action to be executed at a future time */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

export const $lxm = $nsid

/** Schedule a takedown action */
type Takedown = {
  $type?: 'tools.ozone.moderation.scheduleAction#takedown'
  comment?: string

  /**
   * Indicates how long the takedown should be in effect before automatically expiring.
   */
  durationInHours?: number

  /**
   * If true, all other reports on content authored by this account will be resolved (acknowledged).
   */
  acknowledgeAccountSubjects?: boolean

  /**
   * Names/Keywords of the policies that drove the decision.
   */
  policies?: string[]

  /**
   * Severity level of the violation (e.g., 'sev-0', 'sev-1', 'sev-2', etc.).
   */
  severityLevel?: string

  /**
   * Number of strikes to assign to the user when takedown is applied.
   */
  strikeCount?: number

  /**
   * When the strike should expire. If not provided, the strike never expires.
   */
  strikeExpiresAt?: l.DatetimeString

  /**
   * Email content to be sent to the user upon takedown.
   */
  emailContent?: string

  /**
   * Subject of the email to be sent to the user upon takedown.
   */
  emailSubject?: string
}

export type { Takedown }

/** Schedule a takedown action */
const takedown = /*#__PURE__*/ l.typedObject<Takedown>(
  $nsid,
  'takedown',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    durationInHours: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    acknowledgeAccountSubjects: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.boolean(),
    ),
    policies: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string(), { maxLength: 5 }),
    ),
    severityLevel: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    strikeCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    strikeExpiresAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    emailContent: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    emailSubject: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { takedown }

/** Configuration for when the action should be executed */
type SchedulingConfig = {
  $type?: 'tools.ozone.moderation.scheduleAction#schedulingConfig'

  /**
   * Exact time to execute the action
   */
  executeAt?: l.DatetimeString

  /**
   * Earliest time to execute the action (for randomized scheduling)
   */
  executeAfter?: l.DatetimeString

  /**
   * Latest time to execute the action (for randomized scheduling)
   */
  executeUntil?: l.DatetimeString
}

export type { SchedulingConfig }

/** Configuration for when the action should be executed */
const schedulingConfig = /*#__PURE__*/ l.typedObject<SchedulingConfig>(
  $nsid,
  'schedulingConfig',
  /*#__PURE__*/ l.object({
    executeAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    executeAfter: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    executeUntil: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { schedulingConfig }

type ScheduledActionResults = {
  $type?: 'tools.ozone.moderation.scheduleAction#scheduledActionResults'
  succeeded: l.DidString[]
  failed: FailedScheduling[]
}

export type { ScheduledActionResults }

const scheduledActionResults =
  /*#__PURE__*/ l.typedObject<ScheduledActionResults>(
    $nsid,
    'scheduledActionResults',
    /*#__PURE__*/ l.object({
      succeeded: /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.string({ format: 'did' }),
      ),
      failed: /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<FailedScheduling>((() => failedScheduling) as any),
      ),
    }),
  )

export { scheduledActionResults }

type FailedScheduling = {
  $type?: 'tools.ozone.moderation.scheduleAction#failedScheduling'
  subject: l.DidString
  error: string
  errorCode?: string
}

export type { FailedScheduling }

const failedScheduling = /*#__PURE__*/ l.typedObject<FailedScheduling>(
  $nsid,
  'failedScheduling',
  /*#__PURE__*/ l.object({
    subject: /*#__PURE__*/ l.string({ format: 'did' }),
    error: /*#__PURE__*/ l.string(),
    errorCode: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { failedScheduling }
